import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  blogCategoriesCrud,
  blogCategoryDelete,
} from './proxyurls';
import Layout from './layout';

function ManageBlogCategories() {
  const [categories, setCategories] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    const msg = localStorage.getItem('successMessage');
    if (msg) {
      setSuccessMessage(msg);
      localStorage.removeItem('successMessage');
      setTimeout(() => setSuccessMessage(''), 3000);
    }
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(blogCategoriesCrud, {
        withCredentials: true,
      });
      const data = response.data;
      const categoriesData = Array.isArray(data)
        ? data
        : data?.categories || data?.data || [];
      setCategories(categoriesData);
    } catch (error) {
      console.error('Error fetching blog categories:', error);
      setErrorMessage(error.response?.data?.error || 'Error fetching categories');
      setCategories([]);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this category?'
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(blogCategoryDelete(id), {
        withCredentials: true,
      });
      setCategories((prev) => prev.filter((cat) => cat.id !== id && cat._id !== id));
      setSuccessMessage('Category deleted successfully');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error deleting category:', error);
      setErrorMessage(
        error.response?.data?.error || error.response?.data?.message || 'Error deleting category'
      );
      setTimeout(() => setErrorMessage(''), 3000);
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-blog-category/${id}`);
  };

  const handleAdd = () => {
    navigate('/add-blog-category');
  };

  const categoryId = (cat) => cat.id ?? cat._id;

  return (
    <Layout>
      <div style={{ padding: '8px' }}>
        <section className="w-100 p-3">
          <div className="row border-bottom pb-2 mb-3">
            <div className="col-md-8">
              <h4>Manage Blog Categories</h4>
            </div>
            <div className="col-md-4 text-end">
              <button
                type="button"
                className="btn btn-outline-success btn-sm"
                onClick={handleAdd}
              >
                Add Category
              </button>
            </div>
          </div>
          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ padding: '13px' }}>Name</th>
                  <th style={{ padding: '13px' }}>Slug</th>
                  <th style={{ padding: '13px' }}>Description</th>
                  <th style={{ padding: '13px' }}>Status</th>
                  <th style={{ padding: '13px' }}>Created At</th>
                  <th style={{ padding: '13px', width: '13%' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <tr className="table_list" key={categoryId(cat)}>
                      <td>{cat.name || cat.title || 'N/A'}</td>
                      <td>{cat.slug || 'N/A'}</td>
                      <td style={{ maxWidth: '200px' }}>{cat.description || '—'}</td>
                      <td>
                        <span
                          className={`badge rounded-pill ${
                            cat.status === 1 ? 'bg-success' : 'bg-secondary'
                          }`}
                        >
                          {cat.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        {cat.created_at
                          ? new Date(cat.created_at).toLocaleDateString()
                          : 'N/A'}
                      </td>
                      <td>
                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-outline-warning"
                            onClick={() => handleEdit(categoryId(cat))}
                            title="Edit"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(categoryId(cat))}
                            title="Delete"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">No categories available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default ManageBlogCategories;
